<template>
    <b-col class="p-0 h-100" cols="12">
        <b-card :bg-variant="Variant + '-light'" body-class="py-2" class="h-100">
            <b-card-title class="d-flex">
                <b-col cols="8" class="d-flex p-0 align-items-center">
                    <component :is="IconName" class="pr-2"/><h6 class="m-0 font-weight-semibold">{{ $t(TitleKey) }}</h6>
                </b-col>
                <b-col cols="4" class="d-flex justify-content-end">
                    <slot name="top-action"/>
                </b-col>
            </b-card-title>
            <b-row v-for="(field, index) in Fields" :key="index" class="mb-1">
                <b-col cols="6">
                    {{ $t(field.labelKey) }} :
                </b-col>
                <b-col cols="6" class="font-weight-bold">
                    {{ field.value || '\u00A0' }}
                </b-col>
            </b-row>
            <b-col class="d-flex justify-content-start">
                <slot name="bottom-action"/>
            </b-col>
        </b-card>
    </b-col>
</template>
<script lang="ts">
    import { Component, Prop } from 'vue-property-decorator';
    import locale from '../../locales/SMA.json';
    import BaseCard from './BaseCard';

    @Component({
        i18n: { messages: locale }
    })
    export default class InfoCard extends BaseCard {
        /**
         * Propriété spécifique pour les champs textes simples
         */
        @Prop({ default: () => [] })
        public Fields!: Array<{ labelKey: string, value: string }>;
    }
</script>